import React from 'react'
import { Modal } from 'react-bootstrap'
import { t } from '../../i18n';
import Icon from '../../core/ui/atoms/Icon';

interface TransactionInformationModalProps {
    show: boolean;
    onHide: (type: any) => void;
    type?: 'status' | 'transactionId',
}

const TransactionInformationModal: React.FC<TransactionInformationModalProps> = ({ show, onHide, type }) => {
    return (
        <Modal centered show={show} onHide={()=>onHide(undefined)} className={'transaction-modal__container ' + type}>
            <Modal.Header className='transaction-modal__header' closeButton>
                {type == 'status' && <StatusHeader />}
                {type == 'transactionId' && <TransactionIdHeader />}
            </Modal.Header>
            <Modal.Body className='transaction-modal__body'>
                {type == 'status' && <StatusBody />}
                {type == 'transactionId' && <TransactionIdBody />}
            </Modal.Body>
        </Modal>
    )
}

export default TransactionInformationModal

const TransactionIdHeader = () => {
    return (
        <div className='transaction-modal__header-title-wrapper'>
            <Icon name="info" size={24} color='white' className='transaction-modal__icon' />
            <h3 className='transaction-modal__header-title'>{t('transactions.transactionIdModal.title')}</h3>
        </div>
    )
}

const StatusHeader = () => {
    return (
        <>
            <div className='transaction-modal__header-title-wrapper'>
                <Icon name="info" size={24} color='white' className='transaction-modal__icon' />
                <h3 className='transaction-modal__header-title'>{t('transactions.transactionInfoModal.title')}</h3>
            </div>
            <p className='transaction-modal__header-description'>{t('transactions.transactionInfoModal.description1')}</p>
            <p className='transaction-modal__header-description'>{t('transactions.transactionInfoModal.description2')}</p>
        </>
    )
}


const StatusBody = () => {
    return (
        <>
            <div className='transaction-modal__status-divider'><h4>{t('transactions.transactionInfoModal.withdrawDivider')}</h4></div>

            <div className='transaction-modal__status'>
                <h4 className='transaction-modal__status-title'>{t('transactions.transactionInfoModal.withdraw-registered-heading')}</h4>
                <p className='transaction-modal__status-description'>{t('transactions.transactionInfoModal.withdraw-registered-text')}</p>
            </div>
            <div className='transaction-modal__status'>
                <h4 className='transaction-modal__status-title'>{t('transactions.transactionInfoModal.withdraw-inReview-heading')}</h4>
                <p className='transaction-modal__status-description'>{t('transactions.transactionInfoModal.withdraw-inReview-text')}</p>
            </div>
            <div className='transaction-modal__status'>
                <h4 className='transaction-modal__status-title'>{t('transactions.transactionInfoModal.withdraw-pending-heading')}</h4>
                <p className='transaction-modal__status-description'>{t('transactions.transactionInfoModal.withdraw-pending-text')}</p>
            </div>

            <div className='transaction-modal__status-divider deposit'><h4>{t('transactions.transactionInfoModal.depositDivider')}</h4></div>

            <div className='transaction-modal__status'>
                <h4 className='transaction-modal__status-title'>{t('transactions.transactionInfoModal.deposit-pending-heading')}</h4>
                <p className='transaction-modal__status-description'>{t('transactions.transactionInfoModal.deposit-pending-text')}</p>
            </div>
            <div className='transaction-modal__status'>
                <h4 className='transaction-modal__status-title'>{t('transactions.transactionInfoModal.deposit-completed-heading')}</h4>
                <p className='transaction-modal__status-description'>{t('transactions.transactionInfoModal.deposit-completed-text')}</p>
            </div>
        </>
    )
}

const TransactionIdBody = () => {
    return (
        <div className='transaction-modal__transactions'>
            <p className='transaction-modal__transactions-description'>{t('transactions.transactionIdModal.text')}</p>
        </div>
    )
}